// src/features/ask/components/AssistantButton.tsx
//
// The app-bar entry to «Preguntar»: shown only when the API offers the
// assistant to this person (not to Receptionist, not where it is not set up).
// Text plus icon from the tablet up, icon alone on a phone.
import React from 'react';
import { Button, IconButton, Tooltip, useMediaQuery, useTheme } from '@mui/material';
import QuestionAnswerOutlined from '@mui/icons-material/QuestionAnswerOutlined';
import { useTranslate } from 'react-admin';
import { useAssistant } from '../AssistantProvider';

export const AssistantButton: React.FC = () => {
  const translate = useTranslate();
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down('sm'));
  const { enabled, open, setOpen } = useAssistant();
  if (!enabled) return null;

  const label = translate('resources.ask.panel.open');
  if (isPhone) {
    return (
      <Tooltip title={label}>
        <IconButton color="inherit" onClick={() => setOpen(!open)} aria-label={label} aria-pressed={open} sx={{ width: 44, height: 44 }}>
          <QuestionAnswerOutlined />
        </IconButton>
      </Tooltip>
    );
  }
  return (
    <Button
      variant={open ? 'contained' : 'outlined'}
      size="small"
      startIcon={<QuestionAnswerOutlined />}
      onClick={() => setOpen(!open)}
      aria-pressed={open}
      sx={{ mr: 1, whiteSpace: 'nowrap' }}
    >
      {translate('resources.ask.panel.title')}
    </Button>
  );
};

export default AssistantButton;
